export default __webpack_public_path__ + "static/media/login.b6d44769.png";